import { PropsWithChildren } from 'react';

import { styled } from '@mui/material';

import { extractTextMarking, StageWithImage } from '@mewa/ui';

import {
  StrapiImage,
  StrapiResponsiveImageData,
} from '../../templates/dynamic-content-page/content-components/image';

export type StageImageProps = PropsWithChildren<{
  data: {
    headline: string | string[];
    subline: string;
    image: StrapiResponsiveImageData;
  };
}>;

export const StrapiStageImage = ({ data, children }: StageImageProps) => {
  const markedHeadline = Array.isArray(data.headline)
    ? data.headline.map((h) => extractTextMarking(h))
    : [extractTextMarking(data.headline)];

  const stageImage = <StrapiImage responsiveImage={data.image} />;

  return (
    <Wrapper>
      <StageWithImage
        title={markedHeadline}
        subtitle={data.subline}
        image={stageImage}
      >
        {children}
      </StageWithImage>
    </Wrapper>
  );
};

const Wrapper = styled('div')({
  marginBottom: '50px',
});
